import { style } from '@do/walrus';
import styled from 'styled-components';

const NewGoogleButtonWrapper = styled.div`
  margin-top: ${style.vars.whitespace.small};
`;

export default NewGoogleButtonWrapper;
